import { casamapaPartnerPortalPath } from "./casamapaPartnerPortalConfig.js";

/** Partner portal segments for vendor directory workspace (Spanish paths match workspace API). */
export const CASAMAPA_PARTNER_VENDOR_SECTIONS = {
  vendors: "proveedores",
  vendorCreate: "proveedores/nuevo",
  candidates: "candidatos",
  imports: "importaciones",
  duplicates: "duplicados",
  sources: "fuentes",
  collectionPlans: "colecciones/planes",
  collectionRuns: "colecciones/ejecuciones",
  verification: "verificacion",
  credentials: "credenciales",
  claims: "reclamaciones",
  privacy: "privacidad",
  privacyRetention: "privacidad/retencion",
  ranking: "posicionamiento",
  analytics: "analytics",
  maintenance: "mantenimiento",
  pilot: "piloto",
  expansion: "expansion",
  marketplace: "marketplace",
  settings: "configuracion",
};

export function casamapaPartnerVendorHubPath(clientViewId, segment = "") {
  if (!clientViewId) {
    return casamapaPartnerPortalPath("vendors");
  }
  const base = casamapaPartnerPortalPath(`vendors/workspace/${clientViewId}`);
  if (!segment) return base;
  const normalized = String(segment).replace(/^\/+|\/+$/g, "");
  return normalized ? `${base}/${normalized}` : base;
}

export function casamapaPartnerVendorPath(segment = "") {
  return casamapaPartnerPortalPath(segment ? `vendors/${segment}` : "vendors");
}

export function casamapaPartnerVendorManagePath(clientViewId, vendorId) {
  return casamapaPartnerVendorHubPath(clientViewId, `proveedores/${vendorId}`);
}

export { casamapaVendorPublicProfilePath } from "./casamapaVendorWorkspacePaths.js";
